<button class="btn btn-{{btnClass}} btn-primary h-100" (click)="addToLease()" [disabled]="disabled" [ngClass]="{disabled:disabled}">{{"LEASEAPPLICATION"|translate}}</button>
